import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-bottom: 30px;
  justify-content: space-between;
`;
